import { inventoryLotNames } from '../inventory/inventorySelectors'

export default {
  inventoryLotNames (state) {
    return inventoryLotNames(state.inventoryLots)
  }
}
